<template>
    <nav aria-label="Pagination" v-show="getPagesRange.length > 0">
        <ul class="pagination text-center">
            <template v-if="showControls">
                <li v-if="isFirstPage" class="pagination-first disabled"><span>{{ $t('table.page.first') }}</span></li>
                <li v-else class="pagination-first"><button role="button" :title="$t('table.page.first')" @click="onClickFirstPage">{{ $t('table.page.first') }}</button></li>
                <li v-if="isFirstPage" class="pagination-previous disabled"><span>{{ $t('table.page.prev') }}</span></li>
                <li v-else class="pagination-previous"><button role="button" :title="$t('table.page.prev')" @click="onClickPrevPage">{{ $t('table.page.prev') }}</button></li>
            </template>
            <template v-for="page in getPagesRange">
                <li v-if="page.isActive" class="pagination-page current">
                    <span>{{ page.key }}</span>
                </li>
                <li v-else class="pagination-page">
                    <button role="button" :title="page.key" :disabled="page.isDisabled" @click="onClickPage(page.key)">{{ page.key }}</button>
                </li>
            </template>
            <template v-if="showControls">
                <li v-if="isLastPage" class="pagination-next disabled"><span>{{ $t('table.page.next') }}</span></li>
                <li v-else class="pagination-next"><button role="button" :title="$t('table.page.next')" @click="onClickNextPage">{{ $t('table.page.next') }}</button></li>
                <li v-if="isLastPage" class="pagination-last disabled"><span>{{ $t('table.page.last') }}</span></li>
                <li v-else class="pagination-last"><button role="button" :title="$t('table.page.last')" @click="onClickLastPage">{{ $t('table.page.last') }}</button></li>
            </template>
        </ul>
    </nav>
</template>

<script>
    export default {
        props : {
            items : {
                type : Number,
                default : 0
            },
            currentPage : {
                type : [Number, String],
                default : 1
            },
            itemsPerPage : {
                type : Number,
                default : 0
            },
            maxVisiblePages : {
                type : Number,
                default : 5
            },
            showControls : {
                type : Boolean,
                default : true
            }
        },
        computed : {
            getMinPage : function () {
                return this.firstPage = 1;
            },
            getMaxPage : function () {
                return this.lastPage = Math.ceil(this.items / this.itemsPerPage);
            },
            getFirstPage : function () {
                var pages = Math.floor((this.maxVisiblePages - 1) / 2);

                if (this.currentPage <= ((this.getMinPage - 1) + pages)) {
                    return this.getMinPage;
                }

                if (this.currentPage >= (this.getMaxPage - pages)) {
                    return Math.max(this.getMinPage, this.getMaxPage - this.maxVisiblePages + 1);
                }

                return Math.max(this.getMinPage, this.currentPage - pages);
            },
            getLastPage : function () {
                return Math.min(this.getFirstPage + this.maxVisiblePages - 1, this.getMaxPage);
            },
            getPagesRange : function () {
                var range = [];

                for (var i = this.getFirstPage; i <= this.getLastPage; i++) {
                    range.push({
                        key         : i,
                        isActive    : i === parseInt(this.currentPage)
                    });
                }

                return range;
            },
            isFirstPage: function () {
                return this.currentPage <= this.getMinPage;
            },
            isLastPage: function () {
                return this.currentPage >= this.getMaxPage;
            },
        },
        methods : {
            onClickPage : function (page) {
                this.currentPage = page;

                this.$emit('pageClicked', this.currentPage);
            },
            onClickPrevPage : function (page) {
                this.currentPage = this.currentPage - 1;

                this.$emit('pageClicked', this.currentPage);
            },
            onClickNextPage : function (page) {
                this.currentPage = this.currentPage + 1;

                this.$emit('pageClicked', this.currentPage);
            },
            onClickFirstPage : function (page) {
                this.currentPage = this.firstPage;

                this.$emit('pageClicked', this.currentPage);
            },
            onClickLastPage : function (page) {
                this.currentPage = this.lastPage;

                this.$emit('pageClicked', this.currentPage);
            }
        }
    }
</script>